/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsHearAbout204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsHearAbout505Schema = z.any();

export const optionsHearAboutMutationResponseSchema = z.lazy(() => optionsHearAbout204Schema);
